import { registerPluginNamespace } from 'girder/pluginUtils';

import * as slicer from 'girder_plugins/slicer_cli_web';
registerPluginNamespace('slicer_cli_web', slicer);



// WEBPACK FOOTER //
// ./plugins/slicer_cli_web/web_client/main.js